import { createIcon } from '@chakra-ui/react';

export const MbeSafeValue = createIcon({
  displayName: 'MbeSafeValue',
  viewBox: '0 0 95 113',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="M47.526 2C43.103 8.217 13.586 20.962 2 20.962v45.034C2 87.167 44.974 110.332 47.5 111c2.529-.668 45.5-25.45 45.5-42.633V20.962C80.363 20.962 51.95 8.217 47.526 2zM47.501 54.113v28.443" />
        <path d="M76.238 42.262v28.443L47.5 82.556l-28.737-11.85V42.261" />
        <path d="M76.238 42.262 47.5 54.113l-28.737-11.85v-2.371L47.5 28.041l28.737 11.851zM64.181 47.235l-30.974-13.3" />
      </g>
    </svg>
  ),
});
